exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".parking-name-tooltip{max-width:480px;white-space:normal;word-break:break-all;line-height:20px}.freeze-parking-card-dialog .el-dialog__header{padding:16px 24px}.freeze-parking-card-dialog .el-dialog__body{padding:8px 24px 10px;max-height:70vh;overflow-y:auto}.freeze-parking-card-dialog .el-dialog__footer{padding:10px 24px 16px}.freeze-parking-card-dialog .reason-textarea .el-textarea__inner{padding-bottom:5px}.freeze-parking-card-dialog .reason-textarea .el-input__count{position:static;display:block;margin-top:2px;padding-right:2px;text-align:right;line-height:18px;background:transparent}", ""]);

// exports
